import { useEffect, useState } from "react";
import axiosFetch from "../utils/axiosFetch";
import { useIsMounted } from "./useIsMounted";

const mapFetchStatus = (status) => {
  return { isLoading: status === "loading", isError: status === "rejected" };
};

const useFetchData = ({ endpoint, params, defaultData = {} }) => {
  const { token } = window.localStorage;
  const [data, setData] = useState(defaultData);
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState({});
  const mounted = useIsMounted();
  useEffect(() => {
    (async () => {
      try {
        if (mounted) {
          setStatus('loading');
          const { data } = await axiosFetch.get(endpoint, {
            headers: { Authorization: `Bearer ${token}` },
            params: params
          });
          setData(data);
          setStatus("resolved");
        }
      } catch (error) {
        if (mounted) {
          setError({
            error,
            status: error?.response?.status,
            statusText: error?.response?.statusText,
          });
          if (error?.response?.status === 401) {
            setStatus("unauthorized");
          } else {
            setStatus("rejected");
          }
        }
      }
    })();
  }, [endpoint, token, mounted, params]);

  return { status, data, error };
};

const useAppNotification = ({ endpoint, method = 'get', body,}) => {
  const { token } = window.localStorage;
  const [notification, setNotification] = useState("");
  const [notificationStatus, setNotificationStatus] = useState("loading");
  const [notificationError, setNotificationError] = useState({});
  const mounted = useIsMounted();
  useEffect(() => {
    (async () => {
      try {
        if (mounted) {
          const notification = await axiosFetch({
            method: method,
            url: endpoint,
            data: body,
            headers: { Authorization: `Bearer ${token}` }
          });
          setNotification(notification.data);
          setNotificationStatus("resolved");
        }
      } catch (error) {
        if (mounted) {
          setNotificationError({
            error,
            status: error?.response?.status,
            statusText: error?.response?.statusText,
          });
          if (error?.response?.status === 401) {
            setNotificationStatus("unauthorized");
          } else {
            setNotificationStatus("rejected");
          }
        }
      }
    })();
  }, [endpoint, token, mounted]);
  return { notificationStatus, notification, notificationError };
};

export { useFetchData, mapFetchStatus, useAppNotification};
